import { useState, useEffect } from "react";

interface HeroSectionProps {
  onCTAClick?: () => void;
}

export function HeroSection(_props: HeroSectionProps) {
  return (
    <section className="relative bg-primary overflow-hidden mx-4 mt-4 rounded-2xl rough-shadow">
      {/* Texture Pattern Background */}
      <div className="absolute inset-0 hero-texture pointer-events-none"></div>

      {/* Main Content */}
      <div className="relative z-10 p-8 flex flex-col justify-center items-start space-y-2">
        <h1 className="font-display text-5xl md:text-6xl text-primary-foreground leading-[0.85] rotate-slight origin-bottom-left drop-shadow-md">
          FAITH<br/>
          LOVE<br/>
          HOPE<br/>
          HOME<br/>
          <span className="text-3xl md:text-4xl block mt-2 opacity-90">INSPIRATION</span>
          <span className="text-3xl md:text-4xl block opacity-90">COMMUNITY</span>
        </h1>
      </div>

      {/* Decorative SVG */}
      <svg
        className="absolute bottom-4 right-4 w-24 h-24 text-primary-foreground opacity-20 rotate-moderate"
        fill="currentColor"
        viewBox="0 0 100 100"
      >
        <path d="M10,50 Q30,20 50,50 T90,50" fill="none" stroke="currentColor" strokeWidth="4"></path>
        <circle cx="80" cy="20" fill="currentColor" r="10"></circle>
      </svg>
    </section>
  );
}

const keywords = [
  { text: "Jesus Christ", subtitle: "Our Savior" },
  { text: "Jesus Community", subtitle: "Our Family" },
  { text: "Jubilee in the City", subtitle: "Our Mission" },
];

export function FaithKeywords() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        setCurrentIndex((prev) => (prev + 1) % keywords.length);
        setIsVisible(true);
      }, 300);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="mt-10 px-6 text-center h-24 flex flex-col justify-center items-center">
      <div
        className={`transition-all duration-300 ${
          isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2"
        }`}
      >
        <p className="font-hand text-3xl md:text-4xl text-primary font-bold">
          {keywords[currentIndex].text}
        </p>
        <p className="font-body text-sm text-muted-foreground mt-1">
          {keywords[currentIndex].subtitle}
        </p>
      </div>
      {/* Progress Dots */}
      <div className="flex gap-2 mt-4">
        {keywords.map((_, index) => (
          <div
            key={index}
            className={`w-2 h-2 rounded-full transition-all duration-300 ${
              index === currentIndex ? "bg-primary scale-125" : "bg-primary/30"
            }`}
          />
        ))}
      </div>
    </div>
  );
}